import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            padding: 3,
            width: '100%',
            height: '600px',
            marginTop: 2,
            backgroundColor: colors.color25,
            overflowY: 'auto',
        },
        item: {
            display: 'flex',
            padding: '8px 16px',
            alignItems: 'center',
            gap: 1,
            flexWrap: 'wrap',
            marginBottom: 2
        },
        images: {
            width: '35px',
            height: '35px',
        },
        iconsContainer: {
            width: '60px',
            display: 'flex',
            gap: 1,
            '& .MuiIconButton-root': {
                color: colors.color10,
                padding: '0px',
                '& .MuiSvgIcon-root': {
                    fontSize: '25px',
                },
            },
        },
        text: {
            flex: 1,
            color: colors.color10,
            minWidth: '100px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: 'break-word',
        },
        containerNoCategories: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: colors.backgroundDark,
            '& .MuiSvgIcon-root': {
                fontSize: '40px'
            },
            '& .MuiTypography-root': {
                fontSize: '20px',
                maxWidth: '500px',
                textAlign: 'center',
                fontWeight: 'bold'
            },
        },
        img: {
            width: '200px',
            height: '250px',
        },
    }
}

export { useStyles }
